﻿export class ClientConfig {
    constructor(version: string, getToken: () => string) {
        this.version = version;
        this.getToken = getToken;
    }

    public getToken: () => string;
    public version: string;
}

export class AuthorizedClientBase {
    private readonly config: ClientConfig;

    protected constructor(config: ClientConfig) {
        this.config = config;
    }

    protected transformOptions(options: RequestInit): Promise<RequestInit> {
        const token = this.config.getToken();
        const version = this.config.version;
        if (!token) {
            Promise.reject("Token is not set");
        }

        if (!version) {
            Promise.reject("version is not set");
        }

        options.headers = {
            ...options.headers,
            "X-Api-Version": version,
            Authorization: 'Bearer ' + token
        };

        return Promise.resolve(options);
    }
}
